import api from '@/helpers/api'

const API_BOOKING_MERCHANTS = `/api/client/booking/merchants`

export default {
    namespaced: true,
    state: {
        status: '',
        merchants: [],
        authContext: null,
        errMessage: ''
    },
    mutations: {
        request(state) {
            state.status = "Loading"
        },
        success(state) {
            state.status = "Success"
        },
        error(state, { message }) {
            state.status = "Error"
            state.errMessage = message
        },
        setBookingData(state, { merchants, authContext }) {
            state.merchants = merchants || []
            state.authContext = authContext || null
        }
    },
    actions: {
        fetchConnectedMerchants({ commit }) {
            commit('request')
            return new Promise((resolve, reject) => {
                api.request('get', API_BOOKING_MERCHANTS)
                    .then((result) => {
                        commit('success')
                        const data = result.data?.data || {}
                        commit('setBookingData', {
                            merchants: data.merchants || [],
                            authContext: data.auth_context || null
                        })
                        return resolve(data)
                    })
                    .catch((err) => {
                        const message = err?.response?.data?.message || err?.message || 'Failed to fetch connected merchants'
                        commit('error', { message })
                        return reject(err)
                    })
            })
        }
    },
    getters: {
        connectedMerchants: (state) => state.merchants,
        authContext: (state) => state.authContext,
        isLoading: (state) => state.status === 'Loading'
    }
}
